import React, { useState, useEffect } from 'react'
import { getData } from '../helpers'
import PortfolioList from './PortfolioList'
import { useWindowSize } from '../context/windowSizeContext'

// A React Functional Component that will render the page holding the
// a PortfolioList (filled with its PotfolioListItems) and any other functionality defined
export default function Page({
    title,      // will be used for the page title
    subtitle,   // the subtitle for the hero container (from bulma)
    datasource, // define which datasource is fetched
}) {

    // set up a useState container for the data
    const [data, setData] = useState('')

    // testing to see if windowsize is working properly
    const { width, height } = useWindowSize()

    // fetch the data source
    useEffect(() => {
        getData({ route: datasource })
            .then(data => {
                const list = data?.jobs || data?.education || data?.skills || data?.projects// set the data as one of the sources outputs
                setData(list)
            })
            .catch((error) => console.error(error))
    }, [datasource, setData])

    // if no title is given for the page then return a 404 page not found
    if (!title) {
        return (
            <section className="hero is-info is-large">
                <div className="hero-body">
                    <div className="container">
                        <h1 className="title">404 - Page Not Found</h1>
                        <h2 className="subtitle">Sorry this page doesn't exist</h2>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <div className="Page">
            <div className="page-header">
                <p className="title has-text-centered" title={`Window Size: Width: ${width || 'null'} Height: ${height || 'null'}`}>
                    {title}
                </p>
                <p className="subtitle has-text-centered">{subtitle}</p>
            </div>
            <PortfolioList className={`${title}-list`} data={data} />
        </div>
    )
}
